import React from "react";
import { Link } from "react-router-dom";
import { CommentPingType } from "../../../Constants/commentEnums";
import { appPaths } from "../../../../Common";
import { CommentPing } from "../../../Models/Comment";

type Props = {
  ping: CommentPing;
};

export default class CommentPingDisplay extends React.Component<Props> {
  render() {
    // get the link for this ping if there is one
    let link: string = "";

    switch (this.props.ping.type) {
      case CommentPingType.User:
        link = appPaths.user.root.replace(":username", this.props.ping.code as string);
        break;
      case CommentPingType.Company:
        link = appPaths.company.root.replace(":shortname", this.props.ping.code as string);
        break;
      case CommentPingType.Anonymous:
        return (
          <span className="commentPing anonymous" title="This company is Anonymous">
            @{this.props.ping.text}
          </span>
        );
      default:
        throw new Error(`Invalid ping type "${this.props.ping.type}"`);
    }

    if (link !== "") {
      return (
        <Link to={link} className="commentPing" title="View Profile">
          @{this.props.ping.text}
        </Link>
      );
    }

    return null;

    // if (this.props.ping.type === CommentPingType.Anonymous) {
    //   return (
    //     <span className="commentPing anonymous" title="This company is Anonymous">
    //       @{this.props.ping.text}
    //     </span>
    //   );
    // }
  }
}
